export default __webpack_public_path__ + "static/media/I0001.204dcfd6.png";